import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeThree/K6501.png'
import _imports_1 from '@/assets/themetwo/Close_02-1.png'
import _imports_2 from '@/assets/themetwo/downloadApp.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "text1" }
const _hoisted_3 = { class: "text2" }
const _hoisted_4 = { style: {"padding":"0 20px"} }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "infoText" }
const _hoisted_7 = { style: {"white-space":"pre-line"} }
const _hoisted_8 = { style: {"padding":"15px"} }
const _hoisted_9 = { class: "title2" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "introCard" }
const _hoisted_12 = { class: "title3" }
const _hoisted_13 = { class: "installInfo2" }

import { ref, PropType, computed, watch } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { getNextTimeSlot } from '@/utils/commonFunction';
import { getPWADomain } from '@/api/common';
import { Capacitor } from '@capacitor/core';
import { goToPlayStore, openPopup, closePopup } from '@/view/components/supportFunction';


export default /*@__PURE__*/_defineComponent({
  __name: 'pwaAntiBlockingPopup',
  emits: ['close', 'success', 'error'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n();
const userStore = useUserStore()
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const activityInfo = computed(() => userStore?.PWAConvertData?.config?.popupMessage)
const contactRef = ref()
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const rewardCoin = computed(() => userStore?.PWAConvertData?.config?.rewardCoin)
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const timeDuration = computed(() => userStore?.PWAConvertData?.config?.popupDuration)
const pwaID = computed(() => userStore?.PWAConvertData?.config?.Id)
const pwaDomainInfo = computed(() => userStore?.PWAdomainInfo)
const emits = __emit
const params = {
  show,
  contactRef,
  statusRef,
  loadingRef,
  toastContent,
  isSuccess,
  userStore,
  isOpen,
  canReceivedRewards: canRecievedRewards,
  timeDuration,
  pwaID,
  pwaDomainInfo,
  emits,
  t
}


const open = () => openPopup(params)
const close = () => {
    show.value = false
}

const handlePlayStore = () => goToPlayStore(params)
__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      onClose: close,
      position: "bottom",
      style: {
        minWidth: '100%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '10000'
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_van_row, { class: "headBar" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "5" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "logo" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    })
                  ], -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "15",
                style: {"padding":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pwa.text3')), 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('pwa.text2')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "1",
                offset: "3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", { class: "closeIcon" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "",
                      onClick: close
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('pwa.title')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(activityInfo.value), 1)
            ]),
            _createElementVNode("div", {
              class: "bonusBar",
              onClick: handlePlayStore
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("img", {
                src: _imports_2,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('pwa.bonuses')) + " ", 1),
                _createElementVNode("span", null, "R$ " + _toDisplayString(rewardCoin.value), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('pwa.installIntroTitle')), 1),
            _createElementVNode("div", {
              class: "installInfo",
              innerHTML:  _ctx.$t('pwa.installIntro1')
            }, null, 8, _hoisted_10),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('pwa.installIntroTitle')), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('pwa.installIntro2')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})